/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { gql } from '@apollo/client';
import { graphql } from 'gatsby';
import { jsx } from 'theme-ui';
import ProductPriceExact from './ProductPriceExact';
import ProductPriceRange from './ProductPriceRange';

/**
 *
 * @param {object} props
 * @param {object} props.pricing
 * @param {boolean} [props.showMorePricingInfo=false] Show more info toggle for price ranges
 * @param {boolean} [props.prependPriceType=false] Show RRP, FOB, etc. in price
 * @param {'symbol' | 'code' | 'name'} [props.currencyDisplay]
 * @param {boolean} [props.useGrouping]
 * @returns
 */
export default function ProductPrice({
  pricing,
  prependPriceType = false,
  showMorePricingInfo = false,
  currencyDisplay,
  useGrouping,
  ...rest
}) {
  if (!hasContent(pricing)) return null;
  if (pricing.priceStrategy === 'BY_PRICE')
    return (
      <ProductPriceExact
        pricing={pricing}
        prependPriceType={prependPriceType}
        currencyDisplay={currencyDisplay}
        useGrouping={useGrouping}
        {...rest}
      />
    );
  if (pricing.priceStrategy === 'BY_PRICE_RANGE')
    return (
      <ProductPriceRange
        pricing={pricing}
        showMorePricingInfo={showMorePricingInfo}
        {...rest}
      />
    );
  return null;
}

ProductPrice.hasContent = hasContent;
function hasContent(pricing) {
  if (pricing?.priceStrategy === 'BY_PRICE' && pricing?.price != null)
    return true;
  if (
    pricing?.priceStrategy === 'BY_PRICE_RANGE' &&
    pricing?.priceRange != null
  )
    return true;
  return false;
}

export const fragment = graphql`
  fragment bb_ProductPrice on Bottlebooks_ProductPrice {
    price
    currencyCode: currency(format: RAW)
    priceType
    bottleSize
    priceStrategy
    priceRange
    publicPriceRangeImage {
      fixed(width: 375, height: 200, crop: PAD, gravity: WEST) {
        src
        srcSet
      }
    }
  }
`;

ProductPrice.fragment = gql`
  fragment ProductPrice on ProductPrice {
    price
    currencyCode: currency(format: RAW)
    priceType
    bottleSize
    priceStrategy
    priceRange
    publicPriceRangeImage {
      fixed(width: 375, height: 200, crop: PAD, gravity: WEST) {
        src
        srcSet
      }
    }
  }
`;
